import Tween from "tween.ts"
import Animation from "../Animation";
import Circle from "../../entities/Circle";
import { Coord } from "../../types/Interface";
import { INITIAL_CIRCLE_RADIUS } from "../../types/Config";


export default class DrawCircleAnim extends Animation {
  private Anim = Animation.getInstance();
  private isStopped = false;
  Circle: Circle;
  cCoord: Coord;
  radians: number[];
  radianIndex: number;

  constructor(Circle: Circle, targetRadian: number, radianIndex: number, transparent: boolean, cCoord: Coord, onComp: () => void, resolve: () => void) {
    super();

    this.Circle = Circle;
    this.cCoord = cCoord;
    this.radians = [...Circle.radians];
    this.radianIndex = radianIndex;

    this.rootEventBus.on(this.EnumRootEventBus.cancelledCircleAnim, () => this.isStopped = true);

    if(this.Anim.getIsCancelled()) {
      resolve();
      return 
    };

    const r = { startRadian: this.radians[radianIndex] }
    new Tween.Tween({ ...r })
      .to({ startRadian: targetRadian }, 2000)
      .easing(Tween.Easing.Linear.None)
      .onUpdate(c => {
        if(this.isStopped) {
          onComp();
          return
        }
         
        const radians = [...this.radians]
        radians[radianIndex] = c.startRadian;
        this.Circle.draw({
          radians: radians,
          radius: INITIAL_CIRCLE_RADIUS
        }, transparent)
      })
      .onComplete(() => onComp())
      .start()
  }
}